<template>
    <div>
        <template v-if="!wapShow">
            <header-hove :tab-index="1"></header-hove>
            <div style="background: #ffffff">
                <div class="box">
                <span class="crumbs">
					<span @click="btn_home()" style="cursor: pointer;">首页</span>>
					<span @click="btn_product()" style="cursor: pointer;" >产品</span>
					><span @click="btn_prod()" style="cursor: pointer;">{{title}}</span>
					><span style="font-weight: bold">{{titleDetail}}</span>
					</span>
                    <div class="detail" v-if="obj">
                        <span class="detail-title">产品详情</span>
                        <div class="detail-box flex">
                            <div class="left">
                                <div class="imgs">

                                    <img :src="require('@/assets/image/product/'+obj.image)">
                                </div>
                            </div>
                            <div class="right">
                                <div class="right-box">
                                    <h4>{{obj.title}}</h4>
                                    <div class="jiben">
                                        <span v-if="obj.name">产品名称：{{obj.name}}</span>
                                        <span v-if="obj.CAS">CAS：{{obj.CAS}}</span>
                                    </div>
                                    <div v-if="obj.Industry==industrial? 'block': 'none'" class="Industry" >
                                        <span v-if="obj.Industry.industrial">工业级：{{obj.Industry.industrial}}</span>
                                        <span v-if="obj.Industry.appearance">外观：{{obj.Industry.appearance}}</span>
                                        <span v-if="obj.Industry.purity">纯度：{{obj.Industry.purity}}</span>
                                        <span v-if="obj.Industry.chloride">氯化氢含量：{{obj.Industry.chloride}}</span>
                                        <span v-if="obj.Industry.packing">包装：{{obj.Industry.packing}}</span>
                                        <span v-if="obj.Industry.weight">净重：{{obj.Industry.weight}}</span>
                                        <span v-if="obj.Industry.purpose">用途：{{obj.Industry.purpose}}</span>
                                    </div>
                                    <div v-if="obj.Electronics" class="Industry">
                                        <span v-if="obj.Electronics.electronic">电子级：{{obj.Electronics.electronic}}</span>
                                        <span v-if="obj.Electronics.appearance">外观：{{obj.Electronics.appearance}}</span>
                                        <span v-if="obj.Electronics.purity">纯度：{{obj.Electronics.purity}}</span>
                                        <span v-if="obj.Electronics.packing">包装：{{obj.Electronics.packing}}</span>
                                        <span v-if="obj.Electronics.weight">净重：{{obj.Electronics.weight}}</span>
                                        <span v-if="obj.Electronics.purpose">用途：{{obj.Electronics.purpose}}</span>
                                        <span v-if="obj.Electronics.chloroethanol">氯乙醇：{{obj.Electronics.chloroethanol}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 24px">
                            <span class="detail-title">相关推荐</span>
                            <div class="listBox">
                                <div v-for="item in selectList" :key="item.id">
                                    <div class="lis" v-if="item.id!=obj.id" @click="to_detail(item.id)">
                                        <div class="imgs">
                                            <img :src="require('@/assets/image/product/'+item.image)">
                                        </div>
                                        <div class="name">{{item.name}}</div>
                                    </div>
                                </div>
                                <div style="clear: both"></div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footers></footers>
        </template>
        <template v-else>
            <detail-wap></detail-wap>
        </template>
    </div>

</template>

<script>
    import Footers from "@/components/footer";
    import HeaderHove from "@/components/headerHove";
    import detailWap from "./wap/detail.vue";
    import eventBus from "@/assets/js/eventBus";

    export default {
        name: "productDetail",
        components: {HeaderHove, Footers,detailWap},
        data() {
            return {
                obj: {
                    image:''
                },
                title: '',
                titleDetail: '',
                newEnergy: [],
                nitrileCompound: [],
                basics: [],
                selectList: [],
				tabIndex:-1,
                wapShow:false
            }
        },
        mounted() {
            this.getData(this.$route.query.id);
			this.tabIndex=this.$route.query.tabIndex;
            if(this.$route.query) this.wapShow = this.$route.query.wapShow;
            eventBus.$on("wapShow",(data)=>{
                this.wapShow= data;
            })
        },
        methods: {
			btn_home() {
				this.$router.push('/')
			},
			btn_product() {
				this.$router.push('/product')
			},
			btn_prod() {
				this.$router.push('/product?type='+this.tabIndex)
			},
            getData(id) {
                const newEnergy = this.newEnergy = require('../../assets/JSONData/product/newEnergy.json');
                const nitrileCompound = this.nitrileCompound = require('../../assets/JSONData/product/nitrileCompound.json');
                const basics = this.basics = require('../../assets/JSONData/product/basics.json');
                let list = [];
                list = list.concat(newEnergy);
                list = list.concat(nitrileCompound)
                list = list.concat(basics);
                for (let i in list) {
                    if (list[i].id == id) {
                        this.obj = list[i];
                        if (this.obj.type == 1) {
                            this.title = '新能源材料'
                            this.selectList = this.newEnergy;
                        } else if (this.obj.type == 2) {
                            this.title = '腈类化合物及其衍生物'
                            this.selectList = this.nitrileCompound;
                        } else {
                            this.title = '基础化学品'
                            this.selectList = this.basics;
                        }
                        this.titleDetail = list[i].name
                    }
                }
            },
            to_detail(id) {
                this.getData(id)
            }
        }
    }
</script>

<style scoped>
    h4 {
        margin: 0;
    }

    .box {
        padding-left: 50px;
    }

    .crumbs {
        text-align: left;
        display: block;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
        padding-bottom: 28px;
    }

    .detail .detail-title {
        font-size: 18px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #363A44;
        text-align: left;
        display: block;
        border-left: 5px solid #0067AC;
        padding-left: 10px;
        margin-bottom: 18px;
    }

    .detail-box {
        min-height: 320px;
    }

    .detail-box .left {

    }

    .detail-box .left .imgs {
        width: 304px;
        height: 304px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 2px solid #E6E8EB;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }
    .detail-box .left .imgs img{
        width: 100%;
    }

    .detail-box .right {
        width: 70%;
    }

    .right-box {
        padding-left: 22px;
        text-align: left;
    }

    .right-box h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
        font-weight: 400;
        padding-bottom: 20px;
        display: flex;
        width: 774px;
        border-bottom: 1px solid #E6E8EB;
    }

    .jiben {
        padding-top: 20px;
        padding-bottom: 7px;
    }

    .jiben span {
        display: block;
        padding-bottom: 12px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
    }

    .Industry {
        border-top: 1px solid #E6E8EB;
        padding-top: 20px;
    }

    .Industry span {
        display: block;
        padding-bottom: 12px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
    }

    .listBox {
        background: #ffffff;
        padding: 30px 0 30px 0px;
    }

    .listBox .lis {
        float: left;
        margin-bottom: 24px;
        margin-right: 34px;
        cursor: pointer;
    }

    .listBox .lis .imgs {
        width: 250px;
        height: 192px;
        overflow: hidden;
        border-radius: 10px 10px 0 0;
        border: 2px solid #E6E8EB;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .listBox .lis .imgs img{
        height: 100%;
    }

    .listBox .lis .name {
        width: 250px;
        height: 60px;
        line-height: 60px;
        background: #0067AC;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
        border-radius: 0px 0px 10px 10px;
    }
</style>
